export default __webpack_public_path__ + "static/media/advimg.7d396e59.png";